<script>
    import boilsInfo from '$lib/json/boiliesInfo.json';
	import ProductInfoBlock from '$lib/components/ProductInfoBlock.svelte';
	import Button from '$lib/components/Button.svelte';
	import CentralBlock from '$lib/components/CentralBlock.svelte';
	import BoilFlavour from '$lib/components/BoilFlavour.svelte';
	import { buyVisible } from '../states';
	// import Image from '$lib/components/Image.svelte';
    const {buy, tackle, radius, formFactors, flavours, sink} = boilsInfo;
</script>

<svelte:head>
	<title>Бойлы для рыбалки PROBAITS, купить приманки для ловли рыбы</title>
	<meta name="description" property="og:description" content="Бойлы PROBAITS не вредят здоровью рыбы, помогая их пищеварительной системе. Наши бойлы с успехом применяют на любительских рыбалках" />
    <meta property="og:title" content="Бойлы для рыбалки PROBAITS, купить приманки для ловли рыбы">
    <meta property="og:url" content="https://pro-baits.pro/boilies/">
</svelte:head>

<section class="spray boiliesPage">
    {#if buy}
        {@const {header, text, image, bg, classList, imageWebp} = buy}
        <ProductInfoBlock
            header={{
                label: header.label,
                fontSize: header.fontSize
            }}
            text={{
                label: text.label,
                fontSize: text.fontSize
            }}
            {image}
            {imageWebp}
            {bg}
            {classList}
            headerTag="h1"
            bgType="fill"
        >
            <svelte:fragment slot="afterText">
                <div class="btn_wrap">
                    <Button tag="button" on:click={()=>{buyVisible.set(true)}}>Купить</Button>
                </div>
            </svelte:fragment>
        </ProductInfoBlock>
    {/if}
    {#if tackle}
        {@const {header, text, reverse, classList} = tackle}
        <ProductInfoBlock
            header={{
                label: header.label,
                fontSize: header.fontSize
            }}
            text={{
                label: text.label,
                fontSize: text.fontSize
            }}
            {reverse}
            {classList}
            bgType="none"
        >
            <svelte:fragment slot="image">
                <div class="tackle">
                    <img 
                        class="tackle__img" 
                        src="/images/home/tackle.svg" 
                        alt="{header.label} - купить"
                        loading="lazy"
                        draggable="false"
                        decoding="async"
                        aria-hidden="true"
                    >
                    <!-- <Image
                        className="tackle__spray" 
                        src="/images/boilies/boilUniversal.png"  
                        alt={header.label}
                    /> -->
                    <picture>
                        <source srcset="/images/boilies/webp/boilUniversal.webp" type="image/webp">
                        <img 
                            class="tackle__spray" 
                            src="/images/boilies/boilUniversal.png"  
                            alt={header.label}
                            loading="lazy"
                            draggable="false"
                            decoding="async"
                        >
                    </picture>
                </div>
            </svelte:fragment>
        </ProductInfoBlock>
    {/if}
    {#if radius}
        <CentralBlock
            header={radius.header}
            text={radius.text}
        >
        <svelte:fragment slot="beforeText">
            <img 
                class="beforeRadius" 
                src="/images/before-radius.svg"
                alt={radius.header}
                loading="lazy"
                draggable="false"
                decoding="async"
                aria-hidden="true"
            >
        </svelte:fragment>
        <svelte:fragment slot="afterText">
            <picture>
                <source srcset="/images/radius.svg" type="image/svg+xml" media="(min-width: 992px)">
                <img 
                    class="radius_img" 
                    src="/images/radius-mob.svg"
                    alt={radius.header}
                    loading="lazy"
                    draggable="false"
                    decoding="async"
                    aria-hidden="true"
                >
            </picture>
        </svelte:fragment>
        </CentralBlock>
    {/if}
    {#if sink}
        <CentralBlock
            header={sink.header}
            text={sink.text}
        >
            <svelte:fragment slot="afterText">
                <picture>
                    <source srcset="/images/boilies/webp/sink_n_blur.webp" type="image/webp" media="(min-width: 768px)">
                    <source srcset="/images/boilies/sink_n_blur.png" type="image/png" media="(min-width: 768px)">
                    <source srcset="/images/boilies/webp/sink_n_blur-mob.webp" type="image/webp">
                    <img 
                        class="sink_img" 
                        src="/images/boilies/sink_n_blur-mob.png"
                        alt={sink.header}
                        loading="lazy"
                        draggable="false"
                        decoding="async"
                        aria-hidden="true"
                    >
                </picture>
            </svelte:fragment>
        </CentralBlock>
    {/if}
    {#if formFactors}
        {@const {header, text, image, imageWebp, reverse} = formFactors}
        <ProductInfoBlock 
            header={{
                label: header,
                fontSize: "inherit"
            }}
            text={{
                label: text,
                fontSize: "inherit"
            }}
            imageAriaHidden={true}
            {image}
            {imageWebp}
            {reverse}
            classList="formFactor"
        />
    {/if}
    {#if flavours}
        {@const {header, text, image, list, classList, imageWebp} = flavours}
        <div class="flavours">
            <ProductInfoBlock 
                header={{
                    label: header,
                    fontSize: "inherit"
                }}
                text={{
                    label: text,
                    fontSize: "inherit"
                }}
                imageAriaHidden={true}
                {image}
                {imageWebp}
                {classList}
            />
            <div class="container">
                <div class="flavours__list">
                    {#each list as {image, imageWebp, name}}
                        <BoilFlavour {image} {imageWebp} {name} />
                    {/each}
                </div>
            </div>
        </div>
    {/if}
</section>

<style>
    .flavours{
        margin-top: 3.125rem;
    }
    .btn_wrap{
        width: 21.5rem;
    }
    .flavours__list{
        display: grid;
        max-width: 40rem;
        margin: * auto;
        justify-content: space-between;
        grid-template-columns: repeat(auto-fill, minmax(9.17rem, 10.6rem));
    }
    .boiliesPage :global(.formFactor){
        margin: 3.5rem *;
    }
    @media (min-width:768px){
        .boiliesPage :global(.formFactor img){
            margin: * auto * 4.45rem;
        }
    }
</style>